export const NAME_INPUT_PLACEHOLDER = '田中太郎';
export const EMAIL_INPUT_PLACEHOLDER = 'xxx@gen-drive.com';
export const PHONE_INPUT_PLACEHOLDER = '000-0000-0000';
export const ADDRESS_INPUT_PLACEHOLDER = '東京都千代田区1-1-1';
export const COMPANY_INPUT_PLACEHOLDER = '株式会社〇〇〇';
export const DEPARTMENT_INPUT_PLACEHOLDER = 'マーケティング';
